import { useEffect, useState } from 'react'
import { Button, Card, Flex } from 'antd'
import {
  Debt,
  FormDebtValue,
  ListRequest,
} from 'src/pages/finSystem/debt/types'
import { useUrlFilters } from 'src/libs/useUrlFilters'
import { FILTER_CONFIG_DEBT } from 'src/pages/finSystem/debt/const'
import { debtListLoad } from 'src/pages/finSystem/debt/model'
import {
  useDebtListGate,
  useModalCreateDebt,
  useOptionsWalletWithArchive,
} from 'src/pages/finSystem/debt/hook'
import {
  DebtListFilter,
  DebtListTable,
  SkeletonFilter,
} from 'src/pages/finSystem/debt/components'
import dayjs from 'dayjs'
import { PlusOutlined } from '@ant-design/icons'
import { CreateDebtModal } from 'src/pages/finSystem/debt/create'
import { EditDebtModal } from 'src/pages/finSystem/debt/edit'
import { DeleteDebtModal } from 'src/pages/finSystem/debt/delete'
import { Guard } from 'src/features/session/guard'
import { PERMISSIONS } from 'src/features/session/constants'

export const DebtList = () => {
  const [debtEdit, setDebtEdit] = useState<Debt | null>(null)
  const [debtDelete, setDebtDelete] = useState<Debt | null>(null)
  const { isOpenModalCreateDebt, setIsOpenModalCreateDebt } =
    useModalCreateDebt()
  const { filters, setFilters, resetFilters } =
    useUrlFilters(FILTER_CONFIG_DEBT)
  const optionsWalletWithArchive = useOptionsWalletWithArchive()

  const {
    id,
    walletIds,
    dateFilter,
    dateFrom,
    dateTo,
    userId,
    statuses,
    sorterField,
    page,
    pageSize,
  } = filters

  const getInitialValueFormFilter = () => {
    const result = {} as FormDebtValue
    result['dateFilter'] = dateFilter ?? 'date'
    if (dateFrom && dateTo) result['period'] = [dayjs(dateFrom), dayjs(dateTo)]
    if (walletIds) result['walletIds'] = walletIds.map((it) => Number(it))
    if (userId) result['userId'] = userId
    if (statuses) result['statuses'] = statuses.map((it) => String(it))
    return result
  }

  useDebtListGate()

  useEffect(() => {
    debtListLoad({
      id,
      walletIds,
      dateFrom,
      dateTo,
      userId,
      statuses,
      sorterField,
      page,
      pageSize,
    } as ListRequest)
  }, [
    id,
    walletIds,
    dateFrom,
    dateTo,
    userId,
    statuses,
    sorterField,
    page,
    pageSize,
  ])

  return (
    <>
      <Card>
        <Flex justify="space-between">
          {optionsWalletWithArchive.length > 0 ? (
            <DebtListFilter
              filters={filters}
              setFilters={setFilters}
              resetFilters={resetFilters}
              optionsWalletWithArchive={optionsWalletWithArchive}
              initialValueForm={getInitialValueFormFilter()}
            />
          ) : (
            <SkeletonFilter />
          )}
          <Guard
            permission={PERMISSIONS.EDIT_FINSYSTEM_DEBT_TRANSACTION}
            mode="permission"
          >
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => setIsOpenModalCreateDebt(true)}
            >
              Create new debt
            </Button>
          </Guard>
        </Flex>
        <DebtListTable
          setFilters={setFilters}
          sorterField={sorterField}
          setDebtEdit={setDebtEdit}
          setDebtDelete={setDebtDelete}
        />
      </Card>
      <CreateDebtModal
        isOpen={isOpenModalCreateDebt}
        onClose={() => setIsOpenModalCreateDebt(false)}
        filters={filters}
      />
      {debtEdit && (
        <EditDebtModal
          isOpen={Boolean(debtEdit)}
          onClose={() => setDebtEdit(null)}
          initialValues={debtEdit}
          filters={filters}
        />
      )}
      <DeleteDebtModal
        isOpen={Boolean(debtDelete)}
        onClose={() => setDebtDelete(null)}
        item={debtDelete}
        filters={filters}
      />
    </>
  )
}
